function fetchEReservationCache() {
  const now = new Date().getTime();
  // set 48 hour caching for E Cart
  let cachedData = localStorage.getItem("e-reservation");
  cachedData = cachedData && cachedData !== "undefined" ? JSON.parse(cachedData) : null;
  if (cachedData && now - cachedData.timestamp > 178200000) {
    return null;
  }
  return cachedData ? cachedData.value : null;
}

document.addEventListener('DOMContentLoaded', function () {
  const eReservationButton = document.querySelector(".e-reservation-button");
  const productForm = document.querySelector(`#${eReservationButton.dataset.formId}`);
  const modal = document.querySelector(`x-modal[id="${eReservationButton.getAttribute('aria-controls')}"]`);
  const initialFormData = new FormData(productForm);
  const reservationFormSubmitButton = document.querySelector("#e-reservation-step-0-submit");
  const reservationStep0 = document.querySelector(".modal-body.e-reservation-step-0");
  const reservationStep1 = document.querySelector(".modal-body.e-reservation-step-1");
  const reservationStep2 = document.querySelector(".modal-body.e-reservation-step-2");
  const reservationStep3 = document.querySelector(".modal-body.e-reservation-step-3");
  const reservationStep2_1 = document.querySelector('.modal-body .e-reservation-step-2-1');
  const reservationStep2_2 = document.querySelector('.modal-body .e-reservation-step-2-2');
  const reservationStep0Header = document.querySelector(".modal-header.e-reservation-step-0");
  const reservationStep1Header = document.querySelector(".modal-header.e-reservation-step-1");
  const reservationStep2Header = document.querySelector(".modal-header.e-reservation-step-2");
  const reservationStep3Header = document.querySelector(".modal-header.e-reservation-step-3");
  const miniCartSelects = document.querySelectorAll("button.mini-cart-select");
  const contactForm = document.querySelector("#e-reservation-contact");
  const displayType = window.innerWidth < 768 ? "block" : "flex";
  const seriesName = sessionStorage.getItem("seriesName");

  initialFormData.forEach((value, key) => {
    if (key.includes('option') && (!value || value === "")) {
      eReservationButton.classList.add('is-disabled');
    }
  });

  eReservationButton.addEventListener("click", function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    modal.hide();
    const formData = new FormData(productForm);
    let hasEmpty = false;
    let cachedData = fetchEReservationCache();
    const currentProduct = JSON.parse(sessionStorage.getItem("currentProduct"));
    let reservationData = {
      vendor: seriesName,
      title: currentProduct.title,
      images: currentProduct.images,
      options: currentProduct.options,
      price: currentProduct.price
    };
    formData.forEach((value, key) => {
      reservationData[key] = value;
      const span = document.querySelector('.variant-picker__option [is-size-button] span');
      const popover = document.querySelector(`x-popover[data-option="option2"]`);
      if (span && span.hasAttribute('data-not-selected')) {
        if(popover) {
          hasEmpty = true;
          popover.show();
        }
      }
    });

    if (!hasEmpty) {
      eReservationButton.classList.remove('is-disabled');
      reservationData.quantity = 1;
      reservationData.barcode = currentProduct.variants?.find(variant => variant.id.toString() === reservationData.id)?.barcode;
      const newECart = setNewCacheData(cachedData, reservationData);
      const newCacheData = {value: newECart, timestamp: new Date().getTime()};
      localStorage.setItem("e-reservation", JSON.stringify(newCacheData));

      initSteps();
      injectReservationCart(newECart);
      initContactForm();

      modal.show();
    }


  });

  reservationFormSubmitButton.addEventListener("click", function (event) {
    event.preventDefault();
    nextStep(reservationStep0Header, reservationStep0, reservationStep1Header, reservationStep1);
  });

  function waitForThalma(parentElement, button, functionTowait) {
    return new Promise((resolve, reject) => {
      let existingTimeout = parentElement.querySelector('.p-timeout');
      if (existingTimeout) existingTimeout.remove();
      const timeout = document.createElement('p');
      let timeins = 17;
      timeout.classList.add('p-timeout');
      parentElement.appendChild(timeout);
      functionTowait
        .then(() => {
          timeout.remove();
          clearInterval(interval);
          button.disabled = false;
          resolve(true);
        })
        .catch((error) => {
          console.error("Error in functionTowait:", error);
          clearInterval(interval);
          button.disabled = false;
          timeout.remove();
          reject(error);
        });
  
      const interval = setInterval(() => {  
        timeins--;
        if (timeins > 0) {
          timeout.innerHTML = "Vous pourrez réessayer dans quelques instants..." + timeins + "s";
        } else {
          timeout.innerHTML = "Veuillez patienter, le traitement est toujours en cours...";
        }
      }, 1000);
    });
  }

  document.querySelector(".sms-code-button").addEventListener("click", async function (event) {
    event.preventDefault();
    const smsServerError = document.getElementById('sms-code-server-error');
    smsServerError.setAttribute("hidden", true);

    const smsCode = document.getElementById("sms-code").value;
    if (!smsCode || smsCode === "" ) {
      document.getElementById("sms-code").parentElement.classList.add("has-error");
      return;
    }
    const CLT_ID = document.querySelector("input[name='client-id']").value || "-1";
    const button = event.target;
    button.disabled = true;
    await generateEReservation(CLT_ID, smsCode, smsServerError, button);
  });

  document.querySelector("#store-search").addEventListener("click", async function (event) {
    event.preventDefault();
  
    const button = event.currentTarget;
    if (button.disabled) return;
  
    const addressInput = document.querySelector("#localisation_address");
    if (!addressInput || addressInput.value === "") {
      addressInput.parentElement.classList.add("has-error");
      return;
    }
    addressInput.parentElement.classList.remove("has-error");
    const address = addressInput.value;  
    try {
      button.disabled = true;
      let cachedData = fetchEReservationCache();
      const parentElement = document.querySelector('.search-location.js-e-reservation-form');
      await waitForThalma(parentElement,button,injectReservationShops(address, cachedData));
    } catch (error) {
      console.error("Erreur pendant le traitement :", error);
    }
  });  


  window.addEventListener("resize", function(event) {
    let currentDisplayType = window.innerWidth < 768 ? "block" : "flex";
    if (reservationStep0.style.display !== "none") {
      reservationStep0.style.display = currentDisplayType;
    }
    if (reservationStep1.style.display !== "none") {
      reservationStep1.style.display = currentDisplayType;
    }
    if (reservationStep2.style.display !== "none") {
      reservationStep2.style.display = currentDisplayType;
    }
    if (reservationStep3.style.display !== "none") {
      reservationStep3.style.display = currentDisplayType;
    }
  });

  miniCartSelects.forEach(miniCartSelect => miniCartSelect.addEventListener("click", function () {
    const iconsChevronDown = document.querySelectorAll("#icon-mini-cart-open");
    const iconsChevronUp = document.querySelectorAll("#icon-mini-cart-close");
    iconsChevronDown.forEach(iconChevronDown => {
      if (iconChevronDown.style.display !== "none") {
        iconChevronDown.style.display = "none";
        iconsChevronUp.forEach(iconChevronUp => iconChevronUp.style.display = "flex");
        document.querySelectorAll(".e-reservation-mini-basket-items").forEach(miniBasket => {
          miniBasket.classList.remove("hidden-xs");
        });
        miniCartSelect.classList.add("open");
      } else {
        iconsChevronUp.forEach(iconChevronUp => iconChevronUp.style.display = "none");
        iconChevronDown.style.display = "flex";
        document.querySelectorAll(".e-reservation-mini-basket-items").forEach(miniBasket => {
          miniBasket.classList.add("hidden-xs");
        });
        miniCartSelect.classList.remove("open");
      }
    })
  }))

  function initSteps() {
    reservationStep0.style.display = displayType;
    reservationStep0Header.style.display = 'inline-block';
    reservationStep1.style.display = "none";
    reservationStep1Header.style.display = "none";
    reservationStep2.style.display = "none";
    reservationStep2Header.style.display = "none";
    reservationStep3.style.display = "none";
    reservationStep3Header.style.display = "none";
    reservationStep2_1.style.display = "inline-block";
    reservationStep2_2.style.display = "none";
  }

  function nextStep(currentHeader, currentBody, nextHeader, nextBody) {
    nextHeader.style.display = currentHeader.style.display;
    nextBody.style.display = currentBody.style.display;
    currentHeader.style.display = 'none';
    currentBody.style.display = 'none';
  }

  function setNewCacheData(cacheData, newReservation) {
    if (!cacheData) {
      return [newReservation];
    }
    let existingVariant = cacheData.find(variant => variant.id === newReservation.id);
    if (existingVariant) {// can only add one per variant
      return cacheData
    }
    cacheData.push(newReservation);
    return cacheData;
  }

  async function injectReservationShops(address, newCacheData) {
    let shops = await fetchShops(newCacheData, address);
    if (shops && shops.length > 0) {
      document.querySelector(".e-reservation-error-message").style.display = 'none';
      let shopIndex = 0;
      const eReservationShops = document.querySelector(".e-reservation-shops");
      for (shopIndex; shopIndex < shops.length; shopIndex++) {
        if(!shops[shopIndex].MAG_ID)  continue;
        let availableVariants = shops[shopIndex].variants.filter(variant => variant.inStock === true).length;
        let newEReservationShop = document.createElement("div");
        newEReservationShop.classList.add('shop', 'e-reservation-shop');
        newEReservationShop.dataset.shopId = shops[shopIndex].MAG_ID;
        let availabilityStyle = availableVariants < shops[shopIndex].variants.length ? "partially-stock" : "in-stock";
        let variantHtml = "";
        for (let j = 0; j < shops[shopIndex].variants.length; j++) {
          variantHtml += `<p class="availability-body font-primary-tiny">`;
          if (shops[shopIndex].variants[j].inStock) {
            variantHtml += `<span class="point in-stock"></span>`;
          } else {
            variantHtml += `<span class="point out-of-stock"></span>`;
          }

          variantHtml += `
           <span class="article-name">${shops[shopIndex].variants[j].vendor}
              <span class="article-info">(${shops[shopIndex].variants[j].options[0]} : ${shops[shopIndex].variants[j].option1}, ${shops[shopIndex].variants[j].options[1]} : ${shops[shopIndex].variants[j].option2})</span>
          </span>
          </p>`
        }
        newEReservationShop.innerHTML = `
        <div class="shop-info">
            <p class="name headline h3 text-uppercase">${shops[shopIndex].MAG_LB}</p>
            <p class="address">${shops[shopIndex].MAG_ADR}</p>
        </div>

        <div class="availability">
            <p class="availability-title ${availabilityStyle}">
                ${availableVariants}/${shops[shopIndex].variants.length} articles sont disponibles
            </p>
            ${variantHtml}
        </div>
      <button type="button" class="button w-full btn-reserve js-e-reservation-next-step js-e-reservation-shop " data-shop-id="${shops[shopIndex].MAG_ID}">Réserver (${availableVariants} Articles)</button>`
        eReservationShops.appendChild(newEReservationShop);
      }
    }

    document.querySelectorAll(".btn-reserve").forEach(storeSelectButton => {
      storeSelectButton.addEventListener("click", function (event) {
        event.preventDefault();
        const shopId = event.target.dataset.shopId;
        const selectedShop = shops.find(shop => shop.MAG_ID === shopId);

        document.querySelector('.js-shop-name').innerHTML = selectedShop.MAG_LB;
        document.querySelector('.js-shop-address').innerHTML = selectedShop.MAG_ADR;
        document.querySelector('.js-shop-city').innerHTML = selectedShop.MAG_LOCAL;
        document.querySelector('.js-shop-name').setAttribute("data-shop-id", selectedShop.MAG_ID);
        document.querySelector('.js-shop-name').setAttribute("data-pay-id", selectedShop.PAY_ID);
        document.querySelector('.js-shop-name').setAttribute("data-selected-sku-ids", selectedShop.SKU_ids);
        const iconsChevronDown = document.querySelectorAll("#icon-mini-cart-open");
        const iconsChevronUp = document.querySelectorAll("#icon-mini-cart-close");
        iconsChevronDown.forEach(iconsChevronDown => iconsChevronDown.style.display = "flex");
        iconsChevronUp.forEach(iconsChevronUp => iconsChevronUp.style.display = "none");
        document.querySelectorAll(".e-reservation-mini-basket-items").forEach(miniBasket => {
          miniBasket.classList.add("hidden-xs");
        });
        nextStep(reservationStep1Header, reservationStep1, reservationStep2Header, reservationStep2);
      })
    });
  }

  function injectReservationCart(newCacheData) {
    const countElements = document.querySelectorAll(".e-reservation .js-total-count");
    countElements.forEach(countElement => countElement.innerHTML = newCacheData.length);
    const eReservationBasketItems = document.querySelector(".e-reservation-basket-items");
    document.querySelectorAll(".e-reservation-basket-item").forEach(element => element.remove());
    const eReservationMiniBasketItems = document.querySelectorAll(".e-reservation-mini-basket-items");
    document.querySelectorAll(".e-reservation-mini-basket-item").forEach(element => element.remove());
    let totalPrice = 0;
    for (let i = 0; i < newCacheData.length; i++) {
      injectMainECart(newCacheData[i], eReservationBasketItems);
      eReservationMiniBasketItems.forEach(eReservationMiniBasketItemsContainer =>
        injectMiniECart(newCacheData[i], eReservationMiniBasketItemsContainer)
      );
      totalPrice += newCacheData[i].price;
    }
    document.querySelectorAll(".js-total-sum").forEach(
      totalSum => totalSum.innerHTML = ((totalPrice/100).toFixed(2).replace(".", ",") +" €")
    );

    document.querySelectorAll(".js-remove-item").forEach(removeButton => {
      removeButton.addEventListener("click", function (event) {
        const variantId = removeButton.dataset.variantId;
        let cachedData = fetchEReservationCache();
        if(cachedData && cachedData.length > 0) {
          cachedData = cachedData.filter(cachedVariant => cachedVariant.id !== variantId);
        }
        localStorage.setItem('e-reservation', JSON.stringify({value: cachedData, timestamp: new Date().getTime()}));
        countElements.forEach(countElement => countElement.innerHTML = newCacheData.length);
        const variantDivInMainECart = document.querySelector(`.e-reservation-basket-item[data-variant-id="${variantId}"]`);
        document.querySelector(".e-reservation-basket-items").removeChild(variantDivInMainECart);
        const variantDivInMiniECart = document.querySelector(`.e-reservation-mini-basket-item[data-variant-id="${variantId}"]`);
        document.querySelector(".e-reservation-mini-basket-items").removeChild(variantDivInMiniECart);
        if (cachedData.length === 0) {
          document.querySelector(`x-modal[id="${eReservationButton.getAttribute('aria-controls')}"]`).hide();
        }
      });
    })
  }


  function injectMainECart(item, eReservationBasketItems) {
    let price = (item.price/100).toFixed(2).toString().replace('.',',');
    let newEReservationBasketItem = document.createElement("div");
    newEReservationBasketItem.classList.add('e-reservation-basket-item');
    newEReservationBasketItem.dataset.variantId = item.id;
    let image = item.images ? item.images[0] : null;
    newEReservationBasketItem.innerHTML = `
         <div class="row item-row">
          <div class="e-reservation-basket-article-image">
            <img src="${image}" width="auto" height="auto" loading="lazy">
          </div>
          <div class="e-reservation-basket-item-article-infos">
            <div class="row">
                <span class="font-primary-tiny e-reservation-basket-item-article-name text-uppercase">${seriesName}</span>
                <span class="e-reservation-basket-item-article-subname font-primary-small">${item.title}</span>
              <div class="font-primary-tiny e-reservation-basket-item-size">
                <span class="text-medium">${item.options[0]} : ${item.option1}</span><br>
                <span class="text-medium">${item.options[1]} : ${item.option2}</span><br>
                <span class="text-medium">${window.themeVariables.strings.quantity} : ${item.quantity}</span><br>
                <div class="font-primary-small e-reservation-basket-item-price pull-right">
                  <strong>${price} €</strong>
                </div>
                <div class="font-primary-tiny action-section">
                  <span class="js-remove-item" data-variant-id=${item.id}>
                    <svg aria-hidden="true" focusable="false" fill="none" width="11" viewBox="0 0 11 10">
                      <path fill="none" d="M10 9.5l-9-9m9 0l-9 9" stroke="currentColor"></path>
                    </svg>
                    <span>${window.themeVariables.strings.delete_variant}</span>
                  </span></div></div></div></div></div>`;
    eReservationBasketItems.appendChild(newEReservationBasketItem);
  }

  function injectMiniECart(item, eReservationMiniBasketItemsContainer) {
    let price = (item.price/100).toFixed(2).toString().replace('.',',');
    let newEReservationMiniBasketItem = document.createElement("div");
    newEReservationMiniBasketItem.classList.add('row', 'e-reservation-mini-basket-item');
    newEReservationMiniBasketItem.dataset.variantId = item.id;
    let image = item.images ? item.images[0] : null;
    newEReservationMiniBasketItem.innerHTML = `
      <div class="e-reservation-mini-basket-article-image">
        <img src="${image}" alt="Lazy Days" width="auto" height="auto" loading="lazy">
      </div>

      <div class="e-reservation-mini-basket-article-infos">
        <p class="e-reservation-mini-basket-article-name font-primary-tiny text-uppercase">${seriesName}</p>
        <span class="e-reservation-mini-basket-article-subname font-primary-small">${item.title}</span>
        <p class="font-primary-tiny">
          <span class="text-medium">${item.options[0]} : ${item.option1}</span><br>
          <span class="text-medium">${item.options[1]} : ${item.option2}</span><br>
          <span class="text-medium">Quantité : ${item.quantity}</span><br>
          <span class="pull-right">
            <strong>${price} €</strong>
          </span>
        </p>
      </div>`;
    eReservationMiniBasketItemsContainer.appendChild(newEReservationMiniBasketItem);
  }

  async function fetchShops(variants, address) {
    const variantBarcodes = variants.map(variant => variant.barcode);
    const storeSearchError = document.getElementById("search-store-server-error");
    storeSearchError.setAttribute("hidden", true);
    const payload = JSON.stringify({
      SKU_ids: variantBarcodes.join(","),
      Adresse: address
    });
    try {
      document.querySelectorAll(".e-reservation-shop").forEach(element => element.remove());
      const response = await fetch(`/apps/abapp/EReservationGetStores`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: payload,
      });
      if (!response.ok) {// The API return error when the store doesn't found. so just display the notification
        if(response){
          const storeResponse = await response.json();
          if(storeResponse.error){
            storeSearchError.removeAttribute("hidden");
            document.querySelector(".e-reservation-error-message").style.display = "block";
          }
        }
        return;
      }
      const storeResponse = await response.json();
      return groupStores(storeResponse, variants);
    } catch (error) {
      storeSearchError.removeAttribute("hidden");
      console.error('Error:', error);
    }
}

  function groupStores(storeResponse, variants) {
    storeResponse.groupedByBoutique.forEach(store => {
      store.variants = [];
      for (let i = 0; i < variants.length; i++) {
        if (store.SKU_ids.includes(variants[i].barcode) ) {
          store.variants.push({
            vendor: variants[i].vendor,
            title: variants[i].title,
            options: variants[i].options,
            option1: variants[i].option1,
            option2: variants[i].option2,
            id: variants[i].id,
            inStock: true
          });
        } else {
          store.variants.push({
            vendor: variants[i].vendor,
            title: variants[i].title,
            options: variants[i].options,
            option1: variants[i].option1,
            option2: variants[i].option2,
            id: variants[i].id,
            inStock: false
          });
        }
      }
    });
    return storeResponse.groupedByBoutique;
  }
  function initContactForm() {
    document.querySelectorAll(".new-address .oxValidateError").forEach(errorBlock => {
      // init form input
      errorBlock.parentElement.classList.remove("has-error");
      errorBlock.setAttribute("hidden", true);
      if (errorBlock.classList.contains("email-error")){
        document.querySelector(".email .oxValidateError .js-oxError_email").setAttribute('hidden', true);
        document.querySelector(".email .oxValidateError .js-oxError_notEmpty").setAttribute('hidden', true);
        document.querySelector(".email .oxValidateError .js-oxError_maxLength").setAttribute('hidden', true);
      }

      errorBlock.previousElementSibling.addEventListener("click", function(event) {
        errorBlock.parentElement.classList.remove("has-error");
        errorBlock.setAttribute("hidden", true);
        if (errorBlock.classList.contains("email-error")){
          document.querySelector(".email .oxValidateError .js-oxError_email").setAttribute('hidden', true);
          document.querySelector(".email .oxValidateError .js-oxError_notEmpty").setAttribute('hidden', true);
          document.querySelector(".email .oxValidateError .js-oxError_maxLength").setAttribute('hidden', true);
        }
      })
    });

    document.querySelector(".submit-phone-number").addEventListener("click", async function (event) {
      event.preventDefault();
      const setUserError = document.getElementById("contact-info-server-error");
      setUserError.setAttribute("hidden", true);
      let contactInfo = {};
      let invalidFields = [];
      getAndValidateForm(contactInfo, invalidFields);
      const button = event.target;
      if (invalidFields.length === 0) {
        const payload = JSON.stringify({
          CLT_TELM: document.getElementById("telephone-code-selector-input").value + contactInfo["reservation:mobile"],
          CLT_EM: contactInfo["reservation:email"],
          CLT_NOM: contactInfo["reservation:lastname"],
          CLT_PRN: contactInfo["reservation:firstname"]
        });
        try {
          button.disabled = true;
          const parentElement = document.querySelector('.e-reservation-user-information.js-e-reservation-form');
          await waitForThalma(parentElement, button,setUserAndTriggerSMSCode(payload, setUserError));
        } catch (error) {
          console.error('Error:', error);
        }
      }
    });
  }

  function getAndValidateForm(contactInfo, invalidFields) {
    const formData = new FormData(contactForm);
    formData.forEach(function (value, key) {
      contactInfo[key] = value;
      let id = key.split(":")[1];
      if (!value || value === "") {
        invalidFields.push(id);
        let inputElement = document.getElementById(`e_reservation:${id}`);
        inputElement.parentElement.classList.add("has-error");
        if (id === "salutation") {
          document.getElementById("salutation-error").removeAttribute('hidden');
        } else if (id === "email") {
          const errorBlock = inputElement.nextElementSibling;
          errorBlock.removeAttribute('hidden');
          document.querySelector(".email .oxValidateError .js-oxError_notEmpty").removeAttribute('hidden');
        } else {
          inputElement?.nextElementSibling?.removeAttribute('hidden');
        }
      } else {
        let inputElement = document.getElementById(`e_reservation:${id}`);
        inputElement?.parentElement?.classList.remove("has-error");
        inputElement?.nextElementSibling?.setAttribute('hidden', true);
      }
    });
    const checkedSalutation = document.querySelector(`[name="reservation:salutation"]:checked`);
    contactInfo["reservation:salutation"] = checkedSalutation ? checkedSalutation.value : "";
    if (contactInfo["reservation:salutation"] === "") {
      document.getElementById("salutation-error").removeAttribute('hidden');
    }

    if (contactInfo["reservation:email"].length > 100) {
      invalidFields.push("email");
      document.getElementById(`e_reservation:email`).classList.add("has-error");
      document.querySelector(".email .oxValidateError").removeAttribute('hidden');
      document.querySelector(".email .oxValidateError .js-oxError_maxLength").removeAttribute('hidden');
    }

    if(contactInfo["reservation:email"] !== "" && !validateEmail(contactInfo["reservation:email"])){
      invalidFields.push("email");
      document.getElementById(`e_reservation:email`).classList.add("has-error");
      document.querySelector(".email .oxValidateError").removeAttribute('hidden');
      document.querySelector(".email .oxValidateError .js-oxError_email").removeAttribute('hidden');
    }

    if (!document.querySelector(`input[name="reservation[conds]"]`).checked){
      document.querySelector(".checkbox-block .oxValidateError").removeAttribute("hidden");
    }

    return {contactInfo, invalidFields};
  }

  function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  async function generateEReservation(CLT_ID, smsCode, errorDiv, button) {
    const shopId = document.querySelector('.js-shop-name').dataset.shopId;
    const payId = document.querySelector('.js-shop-name').dataset.payId;
    const skuIds = document.querySelector('.js-shop-name').dataset.selectedSkuIds.split(",");
    let quantity = [];
    skuIds.forEach(skuId => quantity.push(1));
    let payload = {};
    let contactInfo = {};
    getAndValidateForm(contactInfo, []);
    if (CLT_ID === "-1") {
      payload = JSON.stringify({
        CLT_ID: CLT_ID,
        CIV_LB: contactInfo["reservation:salutation"],
        CLT_TELM: document.getElementById("telephone-code-selector-input").value + contactInfo["reservation:mobile"],
        CLT_EM: contactInfo["reservation:email"],
        CLT_NOM: contactInfo["reservation:lastname"],
        CLT_PRN: contactInfo["reservation:firstname"],
        SKU_ID: skuIds.join(";"),
        QTE: quantity.join(";"),
        MAG_ID: shopId,
        CODE: smsCode,
        PAY_ID : payId
      });
    } else {
      payload = JSON.stringify({
        CLT_ID: CLT_ID,
        SKU_ID: skuIds.join(";"),
        QTE: quantity.join(";"),
        MAG_ID: shopId,
        CLT_TELM: document.getElementById("telephone-code-selector-input").value + contactInfo["reservation:mobile"],
        CODE: smsCode,
      });
    }

    try {
      const parentElement = document.querySelector('.js-e-reservation-form.e-reservation-check-code');
      await waitForThalma(parentElement, button, EReservationSetReservation(payload, errorDiv));    
    
    } catch (error) {
      errorDiv.removeAttribute("hidden");
      console.error('Error:', error);
    }
  }
  const EReservationSetReservation = async (payload, errorDiv) => {
    const response = await fetch(`/apps/abapp/EReservationSetReservation`, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: payload
      });
      if (!response.ok) {
          errorDiv.removeAttribute("hidden");
          errorDiv.innerHTML = "Code SMS Incorrect";
          throw new Error(`HTTP error! status: ${response.status}`);
      }

      const res = await response.json();
      if (res.result[0][0][1]["ERR_ID"] !== 0) {
        errorDiv.removeAttribute("hidden");
        errorDiv.innerHTML = res.result[0][0][1]["ERR_LB"];
      } else {
        nextStep(reservationStep2Header, reservationStep2, reservationStep3Header, reservationStep3);
      }
  }

  async function setUserAndTriggerSMSCode(payload, setUserError) {
    try {
      const response = await fetch(`/apps/abapp/EReservationSetUser`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: payload
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      let userInfo = await response.json();

      const CLT_ID = userInfo.result.result[0][0][1]["CLT_ID"];
      const clientIdInput = document.querySelector("input[name='client-id']");
      clientIdInput.value = CLT_ID;
      reservationStep2_1.style.display = "none";
      reservationStep2_2.style.display = "inline-block";

    } catch (error) {
      setUserError.removeAttribute("hidden");
    }
  }

  function formatTime(seconds) {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}min ${s}s`;
  }
  
  document.querySelector('.sms-code-resend').addEventListener('click', async function (e) {
    e.preventDefault();
    const resendLink = this;
    
    // Bloque le clic si le bouton est désactivé
    if (resendLink.getAttribute('data-disabled') === 'true') return;
    
    let contactInfo = {};
    let invalidFields = [];
    getAndValidateForm(contactInfo, invalidFields);
    if (invalidFields.length > 0) return;
    
    const payload = JSON.stringify({
      CLT_TELM: document.getElementById("telephone-code-selector-input").value + contactInfo["reservation:mobile"],
      CLT_EM: contactInfo["reservation:email"],
      CLT_NOM: contactInfo["reservation:lastname"],
      CLT_PRN: contactInfo["reservation:firstname"]
    });
    
    const setUserError = document.getElementById("contact-info-server-error");
    setUserError.setAttribute("hidden", true);
    
    try {
      await setUserAndTriggerSMSCode(payload, setUserError);
    } catch (error) {
      console.error('Error lors du renvoi du code SMS :', error);
    }
    
    let countdown = 70;
    // Désactive le lien et ajoute la classe "disabled"
    resendLink.setAttribute('data-disabled', 'true');
    resendLink.classList.add('disabled');
    resendLink.textContent = `Renvoyer le code SMS (${formatTime(countdown - 1)})`;
    
    const timer = setInterval(() => {
      countdown--;
      resendLink.textContent = `Renvoyer le code SMS (${formatTime(countdown - 1)})`;
      if (countdown <= 0) {
        clearInterval(timer);
        resendLink.textContent = "Renvoyer le code SMS";
        // Réactive le lien et retire la classe "disabled"
        resendLink.removeAttribute('data-disabled');
        resendLink.classList.remove('disabled');
      }
    }, 1000);
  });
  
})


